export const splunkRUM = {
  SPLUNK_RUM_AUTH: 'ZLmMG9uH-sn3OmnLY9MabA',
  SPLUNK_BEACON_URL: 'https://rum-ingest.us1.signalfx.com/v1/rum',
  SPLUNK_APP_NAME: 'Manage-Autopay',
};
